// extracted by mini-css-extract-plugin
export default {"root":"ToastsContainer_root__0js-T"};